import { Button, Col, Container, Modal, Row, Form } from "react-bootstrap";
import { Component } from "react";
import AuthenticationQR from "./MaenadaAuthenticationQRIssuer";

/* This is a container dialog for the QR code component. It re emits the onSignInComplete callback.  */

export type AuthenticationModalProps = {
  show?: boolean;
  onCloseClicked?: () => void;
  onSignInComplete: (payload: any) => void;
  token?: string;
  urlRepresentation?: string;
  offerId?: string;
  title?: string;
};

interface AuthenticationModalState {
  authStatus: string;
}

export default class AuthenticationModal extends Component<
  AuthenticationModalProps,
  AuthenticationModalState
> {
  private readonly scanTextMandatory =
    this.props.title;
    private readonly scanTextAll =
    "Credential Identification: Scope";

  constructor(props: AuthenticationModalProps) {
    super(props);
  }

  componentDidMount(): void {
      this.setState({authStatus: ""});
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        animation={true}
        style={{
          height: "100%",
          marginTop: "150px"
        }}
      >
        <Modal.Header
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#352575",
            color: "white",
            alignItems: "center",
          }}
        >
          <Modal.Title>Issuer</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
          <Row>
              <Col className="d-flex">
                <h3>{this.props.title}</h3>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex">
                <h6>
                  Credential Identification: Scope
                </h6>
              </Col>
            </Row>
            <Row>
              <Col
                className="d-flex justify-content-center"
                style={{ paddingTop: "10px" }}
              >
                <AuthenticationQR
                  token={this.props.token}
                  urlRepresentation={this.props.urlRepresentation}
                  offerId={this.props.offerId}
                  onStatusChanged={(status: string) => {
                    this.setState({ authStatus: status });
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <Col className="d-flex">
                <h6>
                  Credential Offer (Raw)
                </h6>
              </Col>
            </Row>
            <Row style={{ marginTop: "10px" }}>
              <Col className="d-flex">
              <textarea style={{width: "100%"}} rows={10} name="credentialOfferRaw" value={this.props.urlRepresentation} disabled={true} />
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  private handleClose = () => {
    this.props.onCloseClicked?.();
  };
}
